import React from "react";
import "./component.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

const AddCorporateUserComponent = (props) => {
  return (
    <div className="bp-form-row">
      <div className="bp-form-column">
        <TextField
          className="bp-form-field"
          fullWidth
          label="Name"
          name="employeeName"
          value={props.createUser.employeeName}
          onChange={(e) => props.handleChangeUser(e)}
        />
        <TextField
          className="bp-form-field"
          fullWidth
          label="Email"
          name="employeeEmail"
          value={props.createUser.employeeEmail}
          onChange={(e) => props.handleChangeUser(e)}
        />
        <TextField
          className="bp-form-field"
          fullWidth
          label="EMP ID"
          name="employeeId"
          value={props.createUser.employeeId}
          onChange={(e) => props.handleChangeUser(e)}
        />
      </div>
    </div>
  );
};

export default AddCorporateUserComponent;